import React from 'react';
import styled from 'styled-components';
import { Box, Div } from '../box';
import Skeleton from '../skeleton';

const VideoPreview = styled(
  ({
    videoSourceUrl,
    className,
    children,
  }: {
    videoSourceUrl: string | undefined;
    className?: string;
    children?: React.ReactNode;
  }) => {
    const [isLoading, setIsLoading] = React.useState(true);

    if (!videoSourceUrl) {
      return null;
    }

    return (
      <Box position={'relative'} className={className} data-testid={'video-preview'}>
        <Skeleton active={isLoading}>
          <Div className={'overlay'} width={'100%'} height={'100%'}>
            <video src={videoSourceUrl} onLoadedData={() => setIsLoading(false)}>
              <track kind={'captions'} srcLang={'en'} label={'Captions'} />
            </video>
          </Div>
        </Skeleton>
        {children}
      </Box>
    );
  },
)`
  z-index: 10;
  max-height: 100%;
  .box-skeleton {
    height: 100%;
    width: 100%;
  }
  video {
    position: relative;
    z-index: -1;
    height: 100%;
    width: 100%;
    display: inherit;
  }
`;

export default VideoPreview;
